import { createAsyncTypes } from 'utils/ActionCreator'

import { CheckCircle, Phishing } from 'components/lib/DesignSystem/Icons'

export const INCIDENT_REQUEST_ASYNC = createAsyncTypes(
  'INCIDENT_REQUEST',
  'ResolutionCenter/AtoIncident'
)

export const PAGINATE_CHANGE = 'ResolutionCenter/AtoIncident/PAGINATE_CHANGE'
export const FILTER_CHANGE = 'ResolutionCenter/AtoIncident/FILTER_CHANGE'

export const ATO_STATES = {
  COMPROMISED: 3,
  SAFE: 2,
}

export const CLASSIFICATION_STATES = [
  {
    state: ATO_STATES.COMPROMISED,
    text: 'Compromised',
    action: 'Remediate Account',
    iconName: 'phishing',
    icon: Phishing,
    iconColor: 'var(--classification-phishing)',
    activeBgColor: 'var(--classification-phishing)',
  },
  {
    state: ATO_STATES.SAFE,
    text: 'Safe',
    action: 'Ignore',
    iconName: 'check-circle',
    icon: CheckCircle,
    iconColor: 'var(--classification-safe)',
    activeBgColor: 'var(--classification-safe)',
  },
]

// Alert icon constants to avoid duplication
const RULE_ALERT_ICON = 'rule-alert'
const LOGIN_ALERT_ICON = 'login-alert'
const OTHER_ALERT_ICON = 'other-alert'

export const ALERTS_ICONS = {
  1: RULE_ALERT_ICON,
  2: LOGIN_ALERT_ICON,
  3: OTHER_ALERT_ICON,
  4: LOGIN_ALERT_ICON, // SIGNINS - use login-alert icon
  5: OTHER_ALERT_ICON, // OUTGOING_EMAIL_ANOMALY - use other-alert icon
  6: OTHER_ALERT_ICON, // DIRECTORY_AUDITS - use other-alert icon
  8: OTHER_ALERT_ICON, // RISK_DETECTION - use other-alert icon
}

// Default fallback icon for unknown alert types
export const DEFAULT_ALERT_ICON = OTHER_ALERT_ICON

/**
 * Get the appropriate icon name for an ATO alert type with fallback protection.
 *
 * @param {number} alertType - The alert type from AccountTakeoverAlerts model
 * @returns {string} The icon filename (without .svg extension)
 *
 * Alert Types:
 * - 1: RULES → rule-alert
 * - 2: LOGIN → login-alert
 * - 3: OTHER → other-alert
 * - 4: SIGNINS → login-alert
 * - 5: OUTGOING_EMAIL_ANOMALY → other-alert
 * - 6: DIRECTORY_AUDITS → other-alert
 * - 8: RISK_DETECTION → other-alert
 * - Unknown types → other-alert (default)
 */
export const getAlertIcon = (alertType) => {
  const icon = ALERTS_ICONS[alertType]

  if (!icon) {
    console.warn(`Unknown ATO alert type: ${alertType}. Using default icon: ${DEFAULT_ALERT_ICON}`)
    return DEFAULT_ALERT_ICON
  }

  return icon
}
